import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { applyStyleModifiers, type ModifiersConfig, type ModifierKeys } from 'styled-components-modifiers';

// Import styles
import { customMinResponsive, size } from 'components/styles';

// Import types
import { Modifiers } from 'types/views/styles';

const HEADING_MODIFIERS: Modifiers = {
	footer: ({ theme }) => css`
		font-size: 1.35em;
		color: ${theme.configurator.color.primary};
		font-weight: ${theme.font.bold};
		padding: 1em 0;

		&:first-child {
			text-align: left;
		}
	`
};

export const TableContainer = styled.div`
	padding: 0 1rem;
	margin-top: 2rem;
	overflow-y: hidden;
	overflow-x: auto;
	text-align: center;
	max-width: 100%;

	&::-webkit-scrollbar {
		height: 1.2rem;
	}

	&::-webkit-scrollbar-track {
		background: ${({ theme }) => theme.configurator.bg.contrast};
		border-radius: 1.2em;
	}

	&::-webkit-scrollbar-thumb {
		background: ${({ theme }) => rgba(theme.configurator.bg.primary, 0.7)};

		border-radius: 1em;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: ${({ theme }) => rgba(theme.configurator.bg.primary, 0.8)};
	}
`;

export const StyledTable = styled.table`
	color: ${({ theme }) => theme.configurator.color.primary};
	border-collapse: collapse;
	border-style: hidden;
	min-width: 35rem;
	margin: 0 auto;
	font-size: 1.2rem;

	${customMinResponsive(
		size.small,
		css`
			font-size: 1.4rem;
		`
	)}

	${customMinResponsive(
		size.medium,
		css`
			font-size: 1.8rem;
		`
	)}
`;

export const StyledHeading = styled.th<{ width?: number; modifiers?: ModifierKeys }>`
	color: ${({ theme }) => theme.configurator.color.accent};
	font-weight: ${({ theme }) => theme.font.medium};
	font-size: 1em;
	line-height: normal;
	padding-bottom: 1.1em;
	width: ${({ width }) => width}px;
	vertical-align: top;
	border: 1px solid ${({ theme }) => rgba(theme.configurator.color.primary, 0.12)};

	${applyStyleModifiers(HEADING_MODIFIERS as ModifiersConfig)};
`;

export const StyledData = styled.td`
	color: ${({ theme }) => theme.configurator.color.secondary};
	font-size: 1.2em;
	font-weight: ${({ theme }) => theme.font.medium};
	padding: 1.2em 0;
	border: 1px solid ${({ theme }) => rgba(theme.configurator.color.primary, 0.12)};

	&:first-child {
		text-align: left;
	}
`;

export const PriceCell = styled.span<{ isPromotion?: boolean }>`
	color: ${({ theme, isPromotion = false }) => (isPromotion ? theme.configurator.color.contrast : theme.configurator.color.primary)};
`;
